module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag31_1564AT.237ec5c2.jpg";